module.exports = __webpack_public_path__ + "img/list.52f92a1c.svg";